/**
 * Enum representing the status of a payment.
 */
export enum PaymentStatus {
	pending = "pending",
	processing = "processing",
	success = "success",
	failed = "failed",
	cancelled = "cancelled",
	declined = "declined",
	refunded = "refunded"
}
